import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompass = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		d: "M10.265 11.639a2 2 0 0 0 1.374-1.374l1.867-6.534a1 1 0 0 0-1.237-1.236L5.735 4.36a2 2 0 0 0-1.374 1.374l-1.866 6.534a1 1 0 0 0 1.236 1.236z"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		d: "M9.333 8a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0Z"
	})]
});
export default SvgCompass;
